<ul class="profile-list profile-list--address">
    <li *ngFor="let address of addressesList">
        <div class="profile-list-item">{{ address.type | translate }}:
        </div>
        <div class="profile-list-option" title="{{address.value}}">{{address.value}}</div>
    </li>
</ul>